(ns ui.view.grid-opensearch.density
  "The row density of the new grid. It is the size option of the ZapKit Table: `:default`
   is `normal`, with a row of 45 px (12 px of padding, a line of 20 px and the 1 px line
   of the row), and `:compact` is `condensed`, with a row of 33 px (6 px of padding). The
   mockup has a third density, Expanded. It is not built, because ZapKit has no size for
   it. The header has two lines when it shows the entity type under the name, and it is as
   high as a row when it has one line. The mockup has the heights 66 px and 54 px for the
   two lines.")

(def densities
  "The densities of the grid, in menu order."
  [:default :compact])

(def default-density
  :default)

(def row-heights
  "The height of a row in pixels, for each density."
  {:default 45
   :compact 33})

(def two-line-header-heights
  "The height of the header in pixels when it has the name and the entity type."
  {:default 66
   :compact 54})

(defn normalize-density
  "The density, or the default density when the value is not a density. A saved value can
   be a string or a keyword."
  [density]
  (let [density (if (string? density)
                  (keyword density)
                  density)]
    (if (contains? row-heights density)
      density
      default-density)))

(defn header-height
  "The height of the header in pixels. It has two lines when `show-entity-type?` is true."
  [{:keys [density show-entity-type?]}]
  (let [density (normalize-density density)]
    (if show-entity-type?
      (get two-line-header-heights density)
      (get row-heights density))))
